
export function SendMessageToServer(_socket, _clientIDRef, _newMessage, _isBroadcast, _setMessageInput = null) {
    if (!_socket || _socket.readyState !== WebSocket.OPEN) {
        console.error("WebSocket is not connected. ", _socket.readyState);
        return;
    }

    if (!_clientIDRef?.current) {
        console.error("Client ID reference is invalid.");
        return;
    }

    if (!_newMessage) {
        console.warn("Message content is empty.");
        return;
    }

    const messageData = {
        TargetID: _clientIDRef.current,
        Content: _newMessage,
        SentFromServer: false,
        IsBroadcast: _isBroadcast
    };

    try {
        _socket.send(JSON.stringify(messageData));
        if (_setMessageInput) {
            _setMessageInput(""); // Clear input if function is provided
        }
    } catch (error) {
        console.error("Error sending message:", error);
    }
}